import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type KeyboardShortcutsType from './view/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const KeyboardShortcuts = lazyAfterPaint<typeof KeyboardShortcutsType>(
	() => import(/* webpackChunkName: "async-keyboard-shortcuts-mapping" */ './view'),
	{ ssr: false },
);
